/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from './core/nav/nav.component.ngfactory';
import * as i5 from '../../app/core/nav/nav.component';
import * as i6 from './core/footer/footer.component.ngfactory';
import * as i7 from '../../app/core/footer/footer.component';
import * as i8 from '../../app/app.component';
import * as i9 from 'angulartics2/dist/providers/ga/angulartics2-ga';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),11,'div',[['class',
      'fixed-donate']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),8,'div',[['class','donate']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n\n        '])),
      (_l()(),i1.ɵeld(4,0,(null as any),(null as any),5,'div',[['class','container center donate-text']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n            This site costs money to run. Consider helping out by '])),
      (_l()(),i1.ɵeld(6,0,(null as any),(null as any),2,'a',[['routerLink','donate']],
          [[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,7).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(7,671744,(null as any),0,i2.RouterLinkWithHref,
          [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['donating'])),(_l()(),i1.ɵted(-1,
          (null as any),['\n        '])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵeld(13,0,(null as any),(null as any),1,'app-nav',([] as any[]),(null as any),
          (null as any),(null as any),i4.View_NavComponent_0,i4.RenderType_NavComponent)),
      i1.ɵdid(14,114688,(null as any),0,i5.NavComponent,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(16,
          16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(17,212992,
          (null as any),0,i2.RouterOutlet,[i2.ChildrenOutletContexts,i1.ViewContainerRef,
              i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
          i1.ɵeld(19,0,(null as any),(null as any),1,'app-footer',([] as any[]),(null as any),
              (null as any),(null as any),i6.View_FooterComponent_0,i6.RenderType_FooterComponent)),
      i1.ɵdid(20,114688,(null as any),0,i7.FooterComponent,([] as any[]),(null as any),
          (null as any))],(_ck,_v) => {
    const currVal_2:any = 'donate';
    _ck(_v,7,0,currVal_2);
    _ck(_v,14,0);
    _ck(_v,17,0);
    _ck(_v,20,0);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,7).target;
    const currVal_1:any = i1.ɵnov(_v,7).href;
    _ck(_v,6,0,currVal_0,currVal_1);
  });
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵdid(1,49152,(null as any),0,i8.AppComponent,[i9.Angulartics2GoogleAnalytics],
          (null as any),(null as any))],(null as any),(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i8.AppComponent> = i1.ɵccf('app-root',
    i8.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjOTQ2MzI5NDcwL3NyYy9mcm9udGVuZC9zcmMvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmM5NDYzMjk0NzAvc3JjL2Zyb250ZW5kL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cyIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjOTQ2MzI5NDcwL3NyYy9mcm9udGVuZC9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjOTQ2MzI5NDcwL3NyYy9mcm9udGVuZC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImZpeGVkLWRvbmF0ZVwiPlxuICAgIDxkaXYgY2xhc3M9XCJkb25hdGVcIj5cblxuICAgICAgICA8ZGl2IGNsYXNzPVwiY29udGFpbmVyIGNlbnRlciBkb25hdGUtdGV4dFwiPlxuICAgICAgICAgICAgVGhpcyBzaXRlIGNvc3RzIG1vbmV5IHRvIHJ1bi4gQ29uc2lkZXIgaGVscGluZyBvdXQgYnkgPGEgcm91dGVyTGluaz1cImRvbmF0ZVwiPmRvbmF0aW5nPC9hPlxuICAgICAgICA8L2Rpdj5cbiAgICA8L2Rpdj5cbjwvZGl2PlxuPGFwcC1uYXY+PC9hcHAtbmF2PlxuPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxuPGFwcC1mb290ZXI+PC9hcHAtZm9vdGVyPiIsIjxhcHAtcm9vdD48L2FwcC1yb290PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUEwQiw4Q0FDdEI7VUFBQTtVQUFBLDhCQUFvQjtNQUVoQjtVQUFBO01BQTBDO01BQ2dCO1VBQUE7WUFBQTtZQUFBO2NBQUE7a0JBQUE7Y0FBQTtZQUFBO1lBQUE7VUFBQSx1Q0FBQTtVQUFBO1VBQUEsZUFBdUIsZ0RBQVk7VUFBQSwrQkFDdkY7TUFDSiwwQ0FDSjtNQUNOO1VBQUE7YUFBQTtVQUFBLGVBQW1CLDBDQUNuQjtVQUFBO1VBQUEsaUVBQUE7VUFBQTswQ0FBQTtVQUFBLDZCQUErQiwwQ0FDL0I7aUJBQUE7Y0FBQTthQUFBO1VBQUE7SUFOcUU7SUFBSCxXQUFHLFNBQUg7SUFJbEU7SUFDQTtJQUNBOztJQU5rRTtJQUFBO0lBQUEsV0FBQSxtQkFBQTs7OztvQkNKbEU7TUFBQTthQUFBO1VBQUE7OzsifQ==



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/$$_gendir/app/app.component.ngfactory.ts